import { apiSend, apiGet } from './client';
import type { Game } from './types';

export function listFavorites() {
  return apiGet<{ favorites: string[] }>('/api/v1/player/favorites');
}

export function addFavorite(game_public_id: string) {
  return apiSend<{ game_public_id: string; created: boolean }>('POST', '/api/v1/player/favorites', {
    game_public_id,
  });
}

export function removeFavorite(game_public_id: string) {
  return apiSend<{ removed: string }>('DELETE', `/api/v1/player/favorites/${encodeURIComponent(game_public_id)}`);
}

export function touchRecent(game_public_id: string) {
  return apiSend<{ game_public_id: string; played_at: string }>('POST', '/api/v1/player/recent', {
    game_public_id,
  });
}

export type RecentEntry = {
  game_public_id: string;
  played_at: string;
  game?: Game;
};

export function listRecent() {
  return apiGet<{ recent: RecentEntry[] }>('/api/v1/player/recent');
}
